/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$('.close_announcement_new').click(function() {
   $('#shopify-section-announcement-footer').hide();
});
